import { mergeAttributes, Node } from '@tiptap/core';

export interface CustomYouTubeIframeOptions {
  src: string;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customYouTubeIframe: {
      setCustomYouTubeIframe: (
        options: CustomYouTubeIframeOptions,
      ) => ReturnType;
    };
  }
}

export const CustomIframe = Node.create({
  //* 노드 이름
  name: 'iframe',

  //* 'iframe' 노드는 블록 그룹에 속합니다.
  group: 'block',

  //* 이 노드는 아톰(atomic) 노드로, 노드 내의 내용을 편집할 수 없습니다.
  atom: true,

  //* 노드가 가질 수 있는 속성을 추가합니다.
  addAttributes() {
    return {
      //* Iframe의 소스 URL을 나타내는 'src' 속성입니다. 기본값은 빈 문자열입니다.
      src: {
        default: '',
      },
      frameborder: {
        default: '0',
      },
      allowfullscreen: {
        default: true,
      },
      class: {
        default: '',
      },
      style: {
        default: '',
      },
    };
  },

  //* HTML을 파싱할 때 이 노드가 어떤 태그를 기반으로 생성될지를 정의합니다.
  parseHTML() {
    return [
      {
        //* 'src' 속성이 있는 'iframe' 태그를 찾습니다.
        tag: 'iframe[src]',
      },
    ];
  },

  //* 노드를 HTML로 렌더링할 때 사용할 태그와 속성을 정의합니다.
  renderHTML({ HTMLAttributes }) {
    return [
      'iframe',
      //* 노드의 기본 HTML 속성과 전달받은 HTML 속성을 병합합니다.
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
    ];
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setCustomYouTubeIframe:
        ({ src }) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              src,
              class: 'w-full h-auto',
              style: 'aspect-ratio: 16 / 9;',
            },
          });
        },
    };
  },
});
